import { render, staticRenderFns } from "./metal.vue?vue&type=template&id=3e53ee46&scoped=true&"
import script from "./metal.vue?vue&type=script&lang=js&"
export * from "./metal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e53ee46",
  null
  
)

export default component.exports